import { NavLink } from "react-router-dom";
import Icon from "./AppIcon";
import Image from "./AppImage";

const FooterPersonalizado = () => {
  // Função para formatar o número do WhatsApp
  const formatPhoneNumber = (phone) => {
    if (!phone) return "";
    // Remove tudo que não for número
    const cleaned = phone.replace(/\D/g, "");

    // Se o número começa com 55 (código do Brasil), remove
    const withoutCountryCode = cleaned.startsWith("55")
      ? cleaned.slice(2)
      : cleaned;

    // Formato: (XX) XXXXX-XXXX
    if (withoutCountryCode.length === 11) {
      return `(${withoutCountryCode.slice(0, 2)}) ${withoutCountryCode.slice(
        2,
        7
      )}-${withoutCountryCode.slice(7)}`;
    }
    // Formato: (XX) XXXX-XXXX
    if (withoutCountryCode.length === 10) {
      return `(${withoutCountryCode.slice(0, 2)}) ${withoutCountryCode.slice(
        2,
        6
      )}-${withoutCountryCode.slice(6)}`;
    }
    return phone;
  };

  const phoneNumber = import.meta.env.VITE_NUMBER_CREATEC;
  const formattedPhone = formatPhoneNumber(phoneNumber);

  return (
    <footer className="bg-white shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] py-8 sm:py-10 md:py-12">
      <div className="container-brand px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {/* Company Info */}
          <div className="sm:col-span-2 lg:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <Image
                src="/assets/images/logo.webp"
                alt="Createc Logo"
                width={150}
                height={50}
                className="h-auto w-auto max-w-[120px] sm:max-w-[150px] object-contain"
              />
            </div>
            <p className="text-gray-700 mb-4 leading-relaxed text-sm sm:text-base">
              Transformando sua visão em software há mais de {(new Date()).getFullYear() - 2023} anos,
              especialistas em desenvolvimento de software e em eficiência
              empresarial em todos os setores.
              Atuamos em empresas de todos os portes, e de todos os lugares do Brasil e do mundo
            </p>
            <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
              <div className="flex items-center space-x-2 text-gray-600">
                <Icon name="MapPin" size={16} className="flex-shrink-0" />
                <span className="text-xs sm:text-sm">Uberlândia, MG</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-600">
                <Icon name="Phone" size={16} className="flex-shrink-0" />
                <a
                  href={import.meta.env.VITE_LINKWHATSAPP_CREATEC}
                  className="hover:text-primary transition-colors text-xs sm:text-sm"
                >
                  {formattedPhone}
                </a>
              </div>
            </div>
          </div>

          {/* Services */}
          <div className="sm:col-span-1">
            <h4 className="font-heading font-semibold text-gray-900 mb-3 sm:mb-4 text-base sm:text-lg">
              Navegações
            </h4>
            <ul className="space-y-2 text-gray-600 text-sm">
              <li className="hover:text-primary transition-colors">
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                  aria-label="Ir para a página inicial"
                >
                  Início
                </NavLink>
              </li>
              <li className="hover:text-primary transition-colors">
                <NavLink
                  to="/solucoes"
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                  aria-label="Conheça nossas soluções"
                >
                  Soluções
                </NavLink>
              </li>
              <li className="hover:text-primary transition-colors">
                <NavLink
                  to="/hospedagem"
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                  aria-label="Veja nossos planos de hospedagem"
                >
                  Hospedagem
                </NavLink>
              </li>
              <li className="hover:text-primary transition-colors">
                <NavLink
                  to="/resultados"
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                  aria-label="Conheça nossos resultados"
                >
                  Resultados
                </NavLink>
              </li>
              <li className="hover:text-primary transition-colors">
                <NavLink
                  to="/contato"
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                  aria-label="Entre em contato conosco"
                >
                  Contato
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="sm:col-span-1">
            <h4 className="font-heading font-semibold text-gray-900 mb-3 sm:mb-4 text-base sm:text-lg">
              Contato
            </h4>
            <ul className="space-y-3 text-gray-600 text-sm">
              <li className="flex items-start space-x-2">
                <Icon name="Mail" size={16} className="flex-shrink-0 mt-0.5" />
                <a
                  href={`${import.meta.env.VITE_LINKEMAIL_CREATEC}`}
                  className="hover:text-primary transition-colors break-words"
                >
                  contato@createc.com.br
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <Icon name="Phone" size={16} className="flex-shrink-0 mt-0.5" />
                <a
                  href={import.meta.env.VITE_LINKWHATSAPP_CREATEC}
                  className="hover:text-primary transition-colors"
                >
                  {formattedPhone}
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <Icon
                  name="Instagram"
                  size={16}
                  className="flex-shrink-0 mt-0.5"
                />
                <a
                  href={import.meta.env.VITE_LINKINSTAGRAM_CREATEC}
                  className="hover:text-primary transition-colors"
                >
                  @createc.com.br
                </a>
              </li>
            </ul>

          </div>
        </div>

        <div className="border-t border-gray-300 mt-6 sm:mt-8 pt-6 sm:pt-8 text-center">
          <p className="text-gray-600 text-xs sm:text-sm">
            © {new Date()?.getFullYear()} Createc. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterPersonalizado;
